import type { Daypart } from "./concierge";

export const CONCIERGE_MEMORY_KEY = "rayk-booking.concierge-memory.v1";

export type ConciergeMemory = {
  enabled: true;
  contact: {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
  };
  selection?: {
    offerSlug: string;
    variantSlug: string;
    locationSlug: string;
    daypart: Daypart;
  };
  updatedAt: string;
};

export function parseConciergeMemory(value: string | null): ConciergeMemory | undefined {
  if (!value) return undefined;

  try {
    const parsed = JSON.parse(value) as Partial<ConciergeMemory>;
    if (parsed.enabled !== true || !parsed.contact || typeof parsed.updatedAt !== "string") {
      return undefined;
    }

    const { firstName, lastName, email, phone } = parsed.contact;
    if ([firstName, lastName, email, phone].some((item) => typeof item !== "string")) {
      return undefined;
    }

    return parsed as ConciergeMemory;
  } catch {
    return undefined;
  }
}

export function memorySelectionSearch(memory: ConciergeMemory): string | undefined {
  const selection = memory.selection;
  if (!selection) return undefined;

  const params = new URLSearchParams();
  params.set("angebot", selection.offerSlug);
  params.set("dauer", selection.variantSlug);
  params.set("ort", selection.locationSlug);
  if (selection.daypart !== "any") params.set("tageszeit", selection.daypart);
  return params.toString();
}
